<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  class={$$props.class}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 3H3.5C3.22386 3 3 2.77614 3 2.5C3 2.22386 3.22386 2 3.5 2H20.5C20.7761 2 21 2.22386 21 2.5C21 2.77614 20.7761 3 20.5 3H19V7.20906C19 7.71534 18.7446 8.18745 18.3209 8.46451L12.9137 12L18.7736 15.8315C18.9149 15.9239 19 16.0812 19 16.25V21H20.5C20.7761 21 21 21.2239 21 21.5C21 21.7761 20.7761 22 20.5 22H3.5C3.22386 22 3 21.7761 3 21.5C3 21.2239 3.22386 21 3.5 21H5V16.25C5 16.0812 5.08513 15.9239 5.22638 15.8315L11.0863 12L5.67913 8.46451C5.25539 8.18745 5 7.71534 5 7.20906V3ZM6 3V7H18V3H6ZM18 18V16.5205L12 12.5974L6 16.5205V18H18Z"
    fill="black"
  />
</svg>
